import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Job } from './job';

export interface JobsStore {
  loaded$: Observable<boolean>;
  allItems$: Observable<Job[]>;
  selectedItem$?: Observable<Job>;

  load(): Observable<Job[]>;
  addItem?(job: Job): void;
  editItem(job: Job): void;
  deleteItem(job: Job): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const JOBS_STORE = new InjectionToken<JobsStore>('JOBS_STORE');
